import { createAsyncThunk } from "@reduxjs/toolkit";
import { type StartRouteParams } from "../../../domain/repos/delivery-repo";
import { type DeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const startRoute = createAsyncThunk<
  void,
  StartRouteParams,
  { dispatch: DeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.START_ROUTE, async (params, { extra }) => {
  await extra.deliveryRepo.startRoute(params);
});
